import { API, graphqlOperation } from "aws-amplify";
import { eventTypeByActiveByAssetType } from "../../../graphql/queries";

import { minValue, number, required } from "react-admin";

import get from "lodash/get";

import { parseTime } from "../../../utils/dateUtils";
import { logError } from "../../../utils/appUtils";

export const fetchEventTypes = async (record, setEvents, notify) => {
  debugger;
  try {
    const searchQuery = {
      reloadYardId: window.appUser?.reloadYardId,
      activeAssetTypeId: {
        eq: {
          active: "true",
          assetTypeId: record.id,
        },
      },
    };
    const results = await API.graphql(
      graphqlOperation(eventTypeByActiveByAssetType, searchQuery)
    );
    const linkedEvents = results.data.eventTypeByActiveByAssetType.items;

    setEvents(linkedEvents);
  } catch (error) {
    logError("assetTypes:AssetTypeUtils:fetchEventTypes", error, notify);
  }
};

export const validateStartTime = (value, allValues, getSource) => {
  const today = new Date();
  const source = getSource("endDayTime");
  const endDayTime = get(allValues, source, null);

  if (!value || !endDayTime) return undefined;

  // Use `value` for real-time validation of the modified field
  const startEventTime = parseTime(value);
  const endEventTime = parseTime(endDayTime);

  const startDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    startEventTime.hour,
    startEventTime.minute
  );

  const endDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    endEventTime.hour,
    endEventTime.minute
  );

  if (startDate >= endDate) {
    return "Must be earlier than end time";
  }

  return undefined;
};

export const validateEndTime = (value, allValues, getSource) => {
  const today = new Date();
  const source = getSource("startDayTime");
  const startDayTime = get(allValues, source, null);

  if (!value || !startDayTime) return undefined;

  // Use `value` for real-time validation of the modified field
  const startEventTime = parseTime(startDayTime);
  const endEventTime = parseTime(value);

  const startDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    startEventTime.hour,
    startEventTime.minute
  );

  const endDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    endEventTime.hour,
    endEventTime.minute
  );

  if (startDate >= endDate) {
    return "Must be later than start time";
  }

  return undefined;
};

export const validateDurationAndBuffer = (value, allValues) => {
  if (!value || !allValues?.schedule?.workdays) return undefined;

  // Filter selected workdays
  const selectedDays = allValues.schedule.workdays.filter(
    (day) => day.selected
  );

  if (!selectedDays.length) return undefined;

  // Find the workday with the **shortest** available time range
  const shortestDay = selectedDays.reduce(
    (shortest, day) => {
      const startWorkTime = parseTime(day.startDayTime);
      const endWorkTime = parseTime(day.endDayTime);
      const availableMinutes =
        endWorkTime.hour * 60 +
        endWorkTime.minute -
        (startWorkTime.hour * 60 + startWorkTime.minute);

      return availableMinutes < shortest.availableMinutes
        ? { day, availableMinutes, startWorkTime, endWorkTime }
        : shortest;
    },
    {
      day: selectedDays[0], // Initialize with the first workday
      availableMinutes: Infinity, // Start with a high number
      startWorkTime: parseTime(selectedDays[0].startDayTime),
      endWorkTime: parseTime(selectedDays[0].endDayTime),
    }
  );

  // Compute event's total required time
  const totalEventMinutes =
    (allValues.duration || 0) + (allValues.bufferTime || 0);

  return totalEventMinutes > shortestDay.availableMinutes
    ? `Exceeds available hours (${shortestDay.day.name}: ${shortestDay.day.startDayTime} - ${shortestDay.day.endDayTime})`
    : undefined;
};

export const validatePositiveNumber = [
  required(),
  number(),
  minValue(0, "Must be 0 or greater"),
];
